import { baseScalesOptions, chartColors, commonTooltipOptions } from '@/utils/chartConfig';
import { useMemo } from 'react';
import type { thematicArea } from '@/features/dashboard/types.api';
import type { comparativeFilterKey } from '../types.props';

const getDefaultThematicAreasChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    scales: {
        x: {
            ...baseScalesOptions.x,
            beginAtZero: true,
            max: 100,
            ticks: { ...baseScalesOptions.x.ticks, font: { size: 12 } },
        },
        y: {
            ...baseScalesOptions.y,
            grid: { display: false },
            ticks: { color: '#CBD5E1', font: { size: 12 } },
        },
    },
    plugins: {
        legend: { display: false },
        tooltip: {
            ...commonTooltipOptions,
        }
    },
});

export const useThematicAreasChart = (
    filteredAreas: thematicArea[],
    currentView: comparativeFilterKey
) => {
    const chartData = useMemo(() => {
        if (filteredAreas.length === 0) {
            return { labels: [], datasets: [] };
        }

        const datasets = [
            {
                label: 'Desempeño',
                data: filteredAreas.map(area => area.performance),
                backgroundColor: chartColors.primaryLight,
            }
        ];

        if (filteredAreas[0]?.comparative_data?.[currentView] !== undefined) {
            datasets.push({
                label: currentView === 'vsInstitution' ? '% Promedio institución' : '% Promedio global',
                data: filteredAreas.map(area => area.comparative_data?.[currentView] || 0),
                backgroundColor: chartColors.secondaryLight,
            });
        }

        return {
            labels: filteredAreas.map(area => area.name),
            datasets,
        };
    }, [filteredAreas, currentView]);

    const chartOptions = useMemo(() => getDefaultThematicAreasChartOptions(), []);

    return { chartData, chartOptions };
};
